import isPropValid from '@emotion/is-prop-valid';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { StyleSheetManager } from 'styled-components';
import { CampaignDashboard } from '@/components/CampaignDashboard/CampaignDashboard';
import { Dashboard } from '@/components/Dashboard/Dashboard';
import { TreeClickTest } from '@/components/TreeClickTest/TreeClickTest';
import GlobalStyles from '@/globalStyles';
import i18n from '@/locales/i18n';

export const App = () => {
  const queryClient = new QueryClient();

  return (
    <BrowserRouter>
      <I18nextProvider i18n={i18n}>
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools initialIsOpen={false} />
          <StyleSheetManager shouldForwardProp={isPropValid}>
            <GlobalStyles />
            <Routes>
              <Route path="/test" element={<TreeClickTest />} />
              <Route path="/campaign/:id" element={<CampaignDashboard />} />
              <Route path="/*" element={<Dashboard />} />
            </Routes>
          </StyleSheetManager>
        </QueryClientProvider>
      </I18nextProvider>
    </BrowserRouter>
  );
};
